import { Box, Stack, TextField, Typography} from "@mui/material";
import { Container } from "@mui/system";
import { LoadingButton } from '@mui/lab';
import {useState } from 'react';
import { useForm } from "react-hook-form";
import SendIcon from '@mui/icons-material/Send';
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';
import { grey } from '@mui/material/colors';
import newDarkChessBg from '../img/dark-chess-bg.png' // Ensure this path is correct

export default function BlindBoard({opLastMove, myLastMove, setMyLastMove, mode, submitMove, hint, useHint, isTurn}) {
    const { handleSubmit } = useForm();
    const [move, setMove] = useState('');
    const [moveError, setMoveError] = useState('');
    const handleChangeMove = (event) => {
        setMove(event.target.value);
    }
    
    const onSubmit = () => {

        if (isTurn && move !== '') {
            let res = submitMove(move);
            if (!res['error']) {
                setMyLastMove(res['move']);
                setMoveError('');
            } else {
                setMoveError(res['error']);
            }
            setMove('');
        }
        
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
          onSubmit()
        }
      }
      
    const InfoRow = ({ label, value, valueColor }) => (
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' } }}>
            <Typography variant="h5" color="white" sx={{ minWidth: { xs: 'auto', sm: '260px' }, fontSize: { xs: '1.1rem', sm: '1.5rem' } }}>
                {label}:
            </Typography>
            <Typography variant="h5" fontWeight="bold" color={valueColor} sx={{ fontSize: { xs: '1.1rem', sm: '1.5rem' } }}>
                {value || '-'}
            </Typography>
        </Box>
    );

    return (
        <Container sx={{
            maxWidth: 720,
            width: '100%',
            aspectRatio: { xs: 'auto', sm: '1 / 1' },
            backgroundColor: '#1e293b',
            borderRadius: 3,
            p: { xs: 2, sm: 3 },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            pt: { xs: 3, sm: 5 }, // Add some padding-top for breathing room
            backgroundImage: `url(${newDarkChessBg})`, // Use the new image here
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        }}>
            <Stack spacing={4}>
                {/* CHANGE 2: Use the new stable InfoRow component */}
                <InfoRow label="Opponent's Last Move" value={opLastMove} valueColor="lightgreen" />
                <InfoRow label="Your Last Move" value={myLastMove} valueColor="lightblue" />
                {mode === 'Custom' && (
                    <InfoRow label="Hints Remaining" value={hint} valueColor="orange" />
                )}

                <Box
                    component="form"
                    onSubmit={handleSubmit(onSubmit)}
                    sx={{
                        backgroundColor: grey[800],
                        p: 2,
                        mt: 2, // Add margin-top to space it from the text above
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        flexWrap: 'wrap'
                        
                    }}
                >
                    <TextField
                        sx={{ flexGrow: 1, minWidth: { xs: '100%', sm: '150px' } }}
                        label="Your Move (e.g., e4, Nf3)"
                        variant="outlined"
                        id="move"
                        value={move}
                        error={!!moveError}
                        helperText={moveError || ''}
                        onChange={handleChangeMove}
                        onKeyDown={handleKeyDown}
                    />
                    <LoadingButton
                        sx={{ width: { xs: '100%', sm: 'auto' } }}
                        size="large"
                        type="submit"
                        loading={!isTurn}
                        loadingIndicator="Waiting…"
                        endIcon={<SendIcon />}
                        variant="contained"
                    >
                        Play
                    </LoadingButton>
                    {mode === 'Custom' && (
                        <LoadingButton
                            sx={{ width: { xs: '100%', sm: 'auto' } }}
                            size="large"
                            onClick={useHint}
                            loading={!isTurn || hint === 0}
                            loadingIndicator={hint === 0 ? "No Hint" : "Waiting…"}
                            endIcon={<NotListedLocationIcon />}
                            variant="contained"
                            color="secondary"
                        >
                            Hint
                        </LoadingButton>
                    )}
                </Box>
            </Stack>
        </Container>
    );
}

